import { DatePicker } from "@/shared/ui/DatePicker";
import { Field } from "@/shared/forms/Field";
import type * as React from "react";
import { Controller, useFormContext } from "react-hook-form";

type CaptionLayout =
  | "label"
  | "dropdown"
  | "dropdown-months"
  | "dropdown-years"
  | undefined;

type FormDatePickerProps = {
  name: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  requiredMark?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  captionLayout?: CaptionLayout;
  fromYear?: number;
  toYear?: number;
};

export function FormDatePicker({
  name,
  label,
  hint,
  requiredMark,
  placeholder,
  disabled,
  className,
  captionLayout,
  fromYear,
  toYear,
}: FormDatePickerProps) {
  const { control } = useFormContext();

  return (
    <Field name={name} label={label} hint={hint} requiredMark={requiredMark}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <DatePicker
            mode="single"
            value={(field.value as Date | null | undefined) ?? null}
            onChange={field.onChange}
            placeholder={placeholder}
            disabled={disabled}
            className={className}
            captionLayout={captionLayout}
            fromYear={fromYear}
            toYear={toYear}
          />
        )}
      />
    </Field>
  );
}
